import { useEffect } from 'react';
import { calculateScreenWidth } from '../utils/screenSizes';

export const useScreenSize = (setScreenWidth) => {
  const calculateAndSetScreenWidth = () => setScreenWidth(calculateScreenWidth());

  useEffect(() => {
    window.addEventListener('resize', calculateAndSetScreenWidth);
    return () => {
      window.removeEventListener('resize', calculateAndSetScreenWidth);
    };
  }, []);
};
